export const AEO_SITE_URL = 'https://selflabs.xyz';
export const AEO_SITE_NAME = 'SELF Labs';
export const AEO_ORG_LEGAL_NAME = 'SELF Labs Inc';

export function aeoAbs(path: string): string {
  if (path.startsWith('http')) return path;
  return `${AEO_SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
